import Vue from 'vue'
import Router from 'vue-router'
import About from '@/components/about'
import Home from '@/pages/home'
import Product from '@/pages/product'
import Service from '@/pages/service'
import ScanCode from '@/pages/scanCode'
import Help from '@/pages/help'
import Partner from '@/pages/partner'
import Apply from '@/pages/apply'
Vue.use(Router)

export default new Router({
    linkActiveClass: 'd-active',
    routes: [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: { showUse: true, showAnimate: true }
    }, {
        path: '/service',
        name: 'Service',
        component: Service,
        meta: { showUse: true, showAnimate: true }
    }, {
        path: '/product',
        name: 'Product',
        component: Product,
        meta: { showUse: true }
    }, {
        path: '/scancode',
        name: 'ScanCode',
        component: ScanCode,
        meta: { showUse: false }
    }, {
        path: '/help',
        name: 'Help',
        component: Help,
        meta: { showUse: true, showAnimate: true }
    }, {
        path: '/partner',
        name: 'Partner',
        component: Partner,
        meta: { showUse: false}
    }, {
        path: '/apply',
        name: 'apply',
        component: Apply,
        meta: { showUse: false,isApply:true}
    }],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js